var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16659 1.66663V4.99996M13.8333 1.66663V4.99996M10.4999 12.5H13.8333M3.83325 9.16663H17.1666M7.16659 12.5H7.24992M5.49992 16.6666H15.4999C16.4204 16.6666 17.1666 15.9204 17.1666 15V4.99996C17.1666 4.07948 16.4204 3.33329 15.4999 3.33329H5.49992C4.57944 3.33329 3.83325 4.07948 3.83325 4.99996V15C3.83325 15.9204 4.57944 16.6666 5.49992 16.6666Z",
    stroke: "#B6BBC1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.520dfadb059e68a35e31ff082327c43b.svg";
export { ForwardRef as ReactComponent };